import { AnyAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../';
import { ValidationStateType } from '../../layouts/devops-screen/types';

type N2NFieldValidationType = {
  readonly email?: ValidationStateType;
  readonly password?: ValidationStateType;
  readonly fullName?: ValidationStateType;
  readonly sitenameNew?: ValidationStateType;
};

type N2NFieldValidationActionType = {
  readonly type: string;
  readonly payload?: {
    readonly fieldName: 'email' | 'password' | 'fullName' | 'sitenameNew';
    readonly validationState?: ValidationStateType;
  };
};

// Actions
const INPUT_VALIDATION_EMAIL = 'n2n-field-validation/INPUT_VALIDATION_EMAIL';
const INPUT_VALIDATION_PASSWORD =
  'n2n-field-validation/INPUT_VALIDATION_PASSWORD';
const INPUT_VALIDATION_FULL_NAME =
  'n2n-field-validation/INPUT_VALIDATION_FULL_NAME';
const INPUT_VALIDATION_SITENAME =
  'n2n-field-validation/INPUT_VALIDATION_SITENAME';

// Initial State
const initialState: N2NFieldValidationType = {
  email: undefined,
  password: undefined,
  fullName: undefined,
  sitenameNew: undefined
};

// Reducer
export const n2nFieldValidationReducer = (
  state = initialState,
  action: N2NFieldValidationActionType
): N2NFieldValidationType => {
  switch (action.type) {
    case INPUT_VALIDATION_EMAIL:
    case INPUT_VALIDATION_PASSWORD:
    case INPUT_VALIDATION_FULL_NAME:
    case INPUT_VALIDATION_SITENAME:
      return Object.assign({}, state, {
        [action?.payload?.fieldName as string]: action?.payload?.validationState
      });
    default:
      return state;
  }
};

// Thunks
export function updateN2NFieldValidationEmail(payload: ValidationStateType) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldValidation: { email }
    } = getState();
    if (email !== payload) {
      dispatch({
        type: INPUT_VALIDATION_EMAIL,
        payload: {
          fieldName: 'email',
          validationState: payload
        }
      });
    }
  }) as unknown as AnyAction;
}

export function updateN2NFieldValidationPassword(payload: ValidationStateType) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldValidation: { password }
    } = getState();
    if (password !== payload) {
      dispatch({
        type: INPUT_VALIDATION_PASSWORD,
        payload: {
          fieldName: 'password',
          validationState: payload
        }
      });
    }
  }) as unknown as AnyAction;
}

export function updateN2NFieldValidationFullName(payload: ValidationStateType) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldValidation: { fullName }
    } = getState();
    if (fullName !== payload) {
      dispatch({
        type: INPUT_VALIDATION_FULL_NAME,
        payload: {
          fieldName: 'fullName',
          validationState: payload
        }
      });
    }
  }) as unknown as AnyAction;
}

export function updateN2NFieldValidationSitename(payload: ValidationStateType) {
  return ((dispatch: AppDispatch, getState: () => RootState) => {
    const {
      n2nFieldValidation: { sitenameNew }
    } = getState();
    if (sitenameNew !== payload) {
      dispatch({
        type: INPUT_VALIDATION_SITENAME,
        payload: {
          fieldName: 'sitenameNew',
          validationState: payload
        }
      });
    }
  }) as unknown as AnyAction;
}
